/**
 * API route helpers for AgentOS endpoints
 */

export const APIRoutes = {
  // Health/config
  Status: (base: string) => `${base.replace(/\/$/, '')}/config`,

  // Directory endpoints
  GetAgents: (base: string) => `${base.replace(/\/$/, '')}/agents`,
  GetTeams: (base: string) => `${base.replace(/\/$/, '')}/teams`,

  // Sessions (if supported by backend)
  GetSessions: (base: string) => `${base.replace(/\/$/, '')}/sessions`,
  GetSession: (base: string, sessionId: string) =>
    `${base.replace(/\/$/, '')}/sessions/${sessionId}/runs`,
  DeleteSession: (base: string, sessionId: string) =>
    `${base.replace(/\/$/, '')}/sessions/${sessionId}`,
  DeleteTeamSession: (base: string, teamId: string, sessionId: string) =>
    `${base.replace(/\/$/, '')}/sessions/${sessionId}`,
  RenameSession: (base: string, sessionId: string) =>
    `${base.replace(/\/$/, '')}/sessions/${sessionId}/rename`,
};

export default APIRoutes;
